<template>
  <b-form-input
    :type="schema.inputType"
    v-model="value"
    :disabled="disabled"
    :required="schema.required"
    :default="schema.default"
    v-bind="bootstrapAttrs"
    v-mask="schema.mask"
  />
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import { GenField, abstractField } from 'vue-form-generator'
import _ from 'lodash'
import AwesomeMask from 'awesome-mask'

@Component({
  directives: {
    mask: AwesomeMask,
  },
})
export default class AwesomeMaskInput extends Mixins(abstractField) {
  schema!: GenField

  public get bootstrapAttrs() {
    return _.pick(this.schema, [
      'size',
      'readonly',
      'plaintext',
      'autocomplete',
      'placeholder',
      'formatter',
      'lazy-formatter',
      'lazy',
      'debounce',
      'no-wheel',
      'min',
      'max',
      'step',
      'list',
      'number',
    ])
  }
}
</script>
